module.exports = __webpack_public_path__ + "static/media/parts_15.45e125b2.svg";